import React from 'react'

const SkeletonNotificationEmail = () => {
    const skeletonCheckbox = 'h-[20px] w-[20px] bg-lightBG rounded-sm animate-pulse'
    const skeletonLabel = 'h-[18px] bg-lightBG rounded w-[100px] animate-pulse'

    return (
        <div className="rounded-[10px] w-full h-full p-[32px] bg-white animate-pulse">
            <div className="flex flex-col gap-3">
                <div className="flex flex-row justify-between items-center">
                    <div className="h-[30px] w-[200px] bg-lightBG rounded"></div>
                    <div className="h-[20px] w-[20px] bg-lightBG rounded-full"></div>
                </div>
                <div className="w-[50%] h-[20px] bg-lightBG rounded"></div>
            </div>

            <div className="flex flex-row justify-between mt-[34px] gap-[40px]">
                <div className="w-1/2 flex flex-col gap-6">
                    <div className="flex flex-row items-center gap-[10px]">
                        <div className="w-[200px] h-[18px] bg-lightBG rounded" />
                        <div className="w-[20px] h-[20px] bg-lightBG rounded-full" />
                    </div>

                    {[...Array(3)].map((_, idx) => (
                        <div key={idx} className="flex flex-row items-center gap-[20px]">
                            <div className={skeletonCheckbox}></div>
                            <div className={skeletonLabel}></div>
                        </div>
                    ))}

                    <div className="flex flex-row items-center gap-[20px]">
                        <div className={skeletonCheckbox}></div>
                        <div className={skeletonLabel}></div>
                    </div>

                    <div className="pl-[40px] pr-[72px] mt-2">
                        <div className="h-[40px] bg-lightBG rounded w-full"></div>
                    </div>
                </div>

                <div className="w-1/2 flex flex-col gap-6">
                    <div className="flex flex-row items-center gap-[10px] justify-between">
                        <div className="w-[260px] h-[18px] bg-lightBG rounded" />
                        <div className="w-[20px] h-[20px] bg-lightBG rounded-full" />
                    </div>

                    {[...Array(3)].map((_, idx) => (
                        <div key={idx} className="flex flex-row items-center gap-[20px]">
                            <div className={skeletonCheckbox}></div>
                            <div className={skeletonLabel}></div>
                        </div>
                    ))}

                    <div className="flex flex-row items-center gap-[20px]">
                        <div className={skeletonCheckbox}></div>
                        <div className={skeletonLabel}></div>
                    </div>

                    <div className="pl-[40px] pr-[72px] mt-2">
                        <div className="h-[40px] bg-lightBG rounded w-full"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SkeletonNotificationEmail
